import React, { useState, useEffect } from "react";
import leftPng from "../../../../content/images/left.png";
import * as omnimap from "../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "./functions/callBackFunctions";
import $ from "jquery";

const Edit = () => {
  async function handleEdit() {
    $("#cover-spin").show(0);
    var actief;
    if ($("#e-algemeen_active").is(":checked")) {
      actief = true;
    } else actief = false;
    var id = $("#e-identification").val();
    var model = {
      content: {
        algemeen: {
          code: $("#e-algemeen-code").val(),
          naam: $("#e-algemeen-naam").val(),
          actief: actief,
          omschrijving: $("#e-algemeen-omschrijving").val(),
          frequentie: $("#e-algemeen-frequentie").val(),
          cyclus: $("#e-algemeen-cyclus").val(),
          maxaantal: $("#e-algemeen-aantal").val(),
          startenna: $("#e-algemeen-starten").val(),
        },
      },
      identification: id,
    };

    let isUnique = true;
    let uniqueModel = {
      content: [
        {
          and_or: "AND",
          datatype: "STRING",
          key: "algemeen-code",
          values: [model.content.algemeen.code],
        },
      ],
      definitions: [process.env.REACT_APP_PLANNINGSPATRONEN],
      sorting: [],
    };

    //** code isunique control.
    await omnimap
      .FillTableAction(uniqueModel, 1, window.$catalog_management_units_token)
      .then(async (result) => {
        if (
          result.data &&
          result.data.length > 0 &&
          result.data[0].identification !== id
        ) {
          isUnique = await false;
          $("#cover-spin").hide(0);

          alert("code is not unique");
        }
      });

    if (isUnique) {
      let result = await omnimap.SaveOrEditAction(
        model,
        "PATCH",
        id,
        window.$catalog_management_units_token
      );
      if (result.result.status === "OK") {
        CallBackFunctions.BeheereenheidEdit();
      }
    }
  }

  return (
    <div id="editSide" className="d-none">
      <div className="detail-title">Planningspatroon in detail</div>
      <div className="clearfix">
        <div className="float-left mt-4">
          <a id="detail-button" className="back-page-link" role="button">
            <img src={leftPng} width={9} height={12} /> &nbsp;Terug naar
            Planningspatroon
          </a>
        </div>
        <div className="float-right mt-0">
          <a id="edit_work_plans" className="button ok" onClick={handleEdit}>
            Opslaan
          </a>
        </div>
        <div className="float-right mt-0 w-20">
          <a id="return-detail" className="button back">
            Annuleren
          </a>
        </div>
      </div>

      <div className="row clearfix">
        <div className="col-lg-4 text-center">
          <div className="box-detail-active">
            <div className="box-title-1-active">Naam</div>
            <div className="box-title-2-active">
              <input
                id="e-algemeen-naam"
                autocomplete="off"
                name="_naam"
                // onChange={handleInputChange}
              />
            </div>
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Code</div>
            <div className="box-title-2">
              <input
                id="e-algemeen-code"
                autocomplete="off"
                name="_code"
                // onChange={() => handleCode(this.value)}
              />
            </div>
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Omschrijving</div>
            <div className="box-title-2">
              <input
                id="e-algemeen-omschrijving"
                autocomplete="off"
                name="_omschrijving"
                // onChange={() => handleOmschrijving(this.value)}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="row clearfix">
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Frequentie</div>
            <div className="box-title-2">
              <input
                id="e-algemeen-frequentie"
                autocomplete="off"
                name="_frequentie"
                // onChange={() => handleFrequentie(this.value)}
              />
            </div>
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Starten Na</div>
            <div className="box-title-2">
              <input
                id="e-algemeen-starten"
                autocomplete="off"
                name="_frequentie"
                // onChange={() => handleFrequentie(this.value)}
              />
            </div>
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Max Aantal</div>
            <div className="box-title-2">
              <input
                id="e-algemeen-aantal"
                autocomplete="off"
                name="_frequentie"
                // onChange={() => handleFrequentie(this.value)}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row clearfix">
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Cyclus</div>
            <div className="box-title-2">
              <input
                id="e-algemeen-cyclus"
                autocomplete="off"
                name="_frequentie"
                // onChange={() => handleFrequentie(this.value)}
              />
            </div>
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Actief</div>
            <label className="switch">
              <input
                id="e-algemeen_active"
                type="checkbox"
                name="actief"
                // onChange={() => handleActief(this.value)}
              />
              <span className="slider-checkbox round" />
            </label>
          </div>
        </div>
      </div>

      <input hidden="true" id="e-identification" />
    </div>
  );
};

export default Edit;
